import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid } from '@material-ui/core';
import { isEmpty } from 'lodash/fp';
import { WarehousesQuery } from '../../../../generated/graphql';
import { Typography } from '../../../../ui-kit';
import WarehouseDetailsCardView from './WarehouseDetailsCard';

interface WarehousesListProps {
    warehouses: WarehousesQuery['warehouses'];
}

const WarehousesListView = ({ warehouses }: WarehousesListProps) => {
    const { t } = useTranslation();

    let content: ReactNode = (
        <Typography>
            {t('No warehouse created')}
        </Typography>
    );

    if (!isEmpty(warehouses)) {
        content = warehouses.map(({ id, name }) => (
            <Box
                key={id}
                width="100%"
                marginBottom={4}
            >
                <WarehouseDetailsCardView
                    id={id}
                    warehouseName={name}
                />
            </Box>
        ));
    }

    return (
        <Grid container justify="center" alignItems="center">
            <Grid item lg={6} md={8} sm={12} xs={12}>
                {content}
            </Grid>
        </Grid>
    );
};

export default WarehousesListView;
